import { setStorageItem } from "@v2/hooks/useLocalStorage";

export const saveCurrentElementId = (elementId: string, storeId: string) => {
  setStorageItem(`elementId-store-${storeId}`, elementId);
};

export const getLastSelectedElementIdForProject = (storeId: string) => {
  return localStorage.getItem(`elementId-store-${storeId}`);
};

export const saveLastSelectedElementIdForTypeForStore = (
  storeId: string,
  type: string,
  elementId: string,
) => {
  return setStorageItem(
    `replo.elementId-store-${storeId}-type-${type}`,
    elementId,
  );
};
